export interface ActivityType {
    label: string;
    value: string;
}

export interface Template {
    label: string;
    value: string;
}

export interface TimeUnit {
    label: string;
    value: string;
}

// API Response wrappers - these match the actual API structure
export interface LinkedInSequencesResponse {
  data: {
    sequences: LinkedInSequence[];
  };
}

// API Response wrappers - these match the actual API structure
export interface OutreachSequencesResponse {
  data: {
    sequences: OutreachSequence[];
  };
}

export interface SequenceStep {
    id: number;
    activityType: ActivityType | null;
    template: Template | null;
    templateName?: string;
    templateBody?: string;
    templateId?: string;
    waitDuration: number;
    waitUnit: TimeUnit | null;
    enableABTesting: boolean;
    variantBContent: string;

}

export interface LinkedInSequence {
    name: string;
    description: string;
    steps: SequenceStep[];
    provider?: string;
    createdDate?: Date;
    updatedAt?: Date;
    action?: string;
    sender:any;
    selectedLeadsList?: LeadsList;
    selectedExcludeList?: LeadsList;
    excludeOptions: any;
    prospectListId?: string;

}

export interface OutreachSequence {
    sequenceId: string;
    name: string;
    status: string;
    steps: number;
    connections: number;
    responses: number;
    providerCampaignId:string;
    created: string;
    linkedInAccountId: number;
}

export interface LinkedInTemplate {
    id?: string;
    name: string;
    type: string;
    content: string;
    provider?: string;
    createdDate?: Date;
    updatedAt?: Date;
}

export const activityTypes: ActivityType[] = [
    { label: 'Message', value: 'message' },
    { label: 'Connection Request', value: 'connection-request' },
    { label: 'InMail', value: 'in-mail' },
    { label: 'Like Post', value: 'like-post' }
];

export const templates: Template[] = [
    { label: 'Select template', value: '' },
    { label: 'Introduction Message', value: 'intro' },
    { label: 'Follow-up Message', value: 'followup' },
    { label: 'Thank You Message', value: 'thankyou' }
];

export const timeUnits: TimeUnit[] = [
    { label: 'Days', value: 'days' },
    { label: 'Hours', value: 'hours' },
    { label: 'Minutes', value: 'minutes' }
];

export interface TemplateType {
    label: string;
    value: string;
}


export const templateTypes: TemplateType[] = [
    { label: 'Message', value: 'message' },
    { label: 'Connection Request', value: 'connection-request' },
    { label: 'InMail', value: 'inmail' },
    { label: 'Like Post', value: 'like-post' }
];

export interface LeadsList {
    count: number
    name: string;
    prospectListId: string;
    linkedInAccountId:string;
}

export interface ExcludeList {
    count: number
    name: string;
    prospectListId: string;
    linkedInAccountId:string;
}

export interface Sender {
    firstName: string;
    lastName: string;
    emailAddress: string;
    icon?: string;
    id: number;
    linkedInAccountId:string;
}
